import * as gfunctions from '../../../js/generalFunctions';

CCL.upSellProductModal = {
  autoload: [
    // ['test', $('.upsellProduct-description').length > 0]
    ['modalEvents', $('.upsellProduct-description').length > 0]
  ],

  isOutSideClick: true,

  // test() {
  //   gfunctions.seeMoreLess('.upsellProduct-description', 'test'); // Apply SeeMore or SeeLess
  // },

  loadUpsellModal(productCode) {
    gfunctions.showLoader();
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/upsell-product.json';
    } else {
      ajaxUrl = `/shop/cart/getupsellproduct?productCode=${productCode}`;
    }
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done((response) => {
      gfunctions.hideLoader();
      this.openUpsellModal(response);
    })
      .fail(() => {
        gfunctions.hideLoader();
        console.log('error Occured');
      });
  },

  async openUpsellModal(dynamicData) {
    gfunctions.showLoader();
    try {
      const inputHtmlObj = {
        url: '/_ui/responsive/ccl/assets/templates/cart-modals/upsell-product-modal.html',
        type: 'GET'
      };
      const response = await gfunctions.doAjax(inputHtmlObj);
      const html = gfunctions.createDynamicHTML(response, dynamicData);
      $('#upsell-product-modal').empty().append(html);
      const prodTitle = dynamicData.productCard.title;
      gfunctions.showModal('upsellProductModal');
      this.isOutSideClick = true;
      gfunctions.hideLoader(); // call all javascript event after above html load
      this.modalClickEvents(prodTitle);
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  modalClickEvents(prodTitle) {
    gfunctions.seeMoreLess('.upsellProduct-description', prodTitle); // Apply SeeMore or SeeLess

    $('#upsell-product-modal').on('hidden.bs.modal', (e) => {
      if (this.isOutSideClick) {
        $('.upSellCloseBtn .checkoutConflictBtn').trigger('click');
      }
    });
    $('#upsell-product-modal').on('click', '.upSellCloseBtn', (e) => {
      this.isOutSideClick = false;
      gfunctions.hideModal('upsellProductModal');
    });

    $('#upsell-product-modal').on('click', '.globalUpSellCloseBtn', (e) => {
      $('.more-details-btn').trigger('click');
    });

    $('#upsell-product-modal').on('click', '.more-details-btn', (e) => {
      this.isOutSideClick = false;
      gfunctions.hideModal('upsellProductModal');
    });

    $('#upsell-product-modal').on('click', '.upsell-add-to-cart-btn', (e) => {
      this.isOutSideClick = false;
      gfunctions.hideModal('upsellProductModal');
    });
  },

  modalEvents() {
    const modalEl = $('#upsellProductModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  },

  loadGlobalUpsellModal(event) {
    gfunctions.showLoader();
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/upsell-product.json';
    } else {
      ajaxUrl = '/shop/cart/productreference';
    }

    let quantity = null;

    if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').length) {
      quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
    } else if ($(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').length) {
      quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input-1').val();
    }

    const bookingIdsArray = $(event.target).attr('data-bookingIds') ? $(event.target).attr('data-bookingIds').split(',') : [];
    const guestIdsArray = $(event.target).attr('data-guestIds') ? $(event.target).attr('data-guestIds').split(',') : [];

    const dataObj = {
      productCode: $(event.target).data('productcode'),
      referenceType: 'UPSELLING',
      qty: quantity || 1,
      encBookingIds: bookingIdsArray,
      encGuestIds: guestIdsArray
    };
    const csrf = $('#csrfSessionToken').data('csrf');

    $.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: csrf
      },
      contentType: 'application/json'
    }).done((response) => {
      gfunctions.hideLoader();
      if (response.productValid) {
        this.openGlobalUpsellModal(response);
      } else {
        $(event.target).attr('data-hasupsell', 'false');
        $(event.target).trigger('click');
      }
    })
      .fail(() => {
        gfunctions.hideLoader();
        console.log('error Occured');
        $(event.target).attr('data-hasupsell', 'false');
        $(event.target).trigger('click');
      });
  },

  async openGlobalUpsellModal(dynamicData) {
    gfunctions.showLoader();
    try {
      const inputHtmlObj = {
        url: '/_ui/responsive/ccl/assets/templates/cart-modals/global-upsell-product-modal.html',
        type: 'GET'
      };

      const { targetProduct, sourceProduct } = dynamicData;
      targetProduct.addCartBtnClass = this.getBtnClass(targetProduct);
      sourceProduct.addCartBtnClass = this.getBtnClass(sourceProduct);

      const response = await gfunctions.doAjax(inputHtmlObj);
      const html = gfunctions.createDynamicHTML(response, dynamicData);
      $('#upsell-product-modal').empty().append(html);
      const prodTitle = dynamicData.targetProduct.productName;

      //  gfunctions.hideModal('termsAndConditionsModal');
      gfunctions.hideModal('alcoholAtcModal');
      //  gfunctions.hideModal('diningAtcModal');
      gfunctions.hideModal('clpAddToCartModal');
      gfunctions.showModal('globalUpsellProductModal');

      setTimeout(() => {
        $('body').addClass('modal-open');
      }, 1000);
      this.isOutSideClick = true;
      gfunctions.hideLoader(); // call all javascript event after above html load
      this.modalClickEvents(prodTitle);
    } catch (err) {
      gfunctions.hideLoader();
      const cartAPIError = { customError: err };
      console.log(cartAPIError);
    }
  },

  getBtnClass(product) {
    let btnClass = 'btn-add-cart';
    if (product.productType === 'SFP') {
      btnClass = 'add-to-cart-sfp';
    } else if (product.productType === 'SFAP' ||
      product.alcoholic === true ||
      (product.productType !== 'FTF' && product.productType !== '') ||
      product.productType !== '') {
      btnClass = 'terms-conditions-btn';
    }

    return btnClass;
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-upsell-product-modal/upsell-product.js